/**
 * Validate if a string is a legitimate URL.
 * Accepts http://, https://, and common shorthand patterns.
 */
export function isValidUrl(str) {
  if (!str || !str.trim()) return false;
  try {
    const trimmed = str.trim();
    // Allow URLs with protocol
    if (/^https?:\/\/.+\..+/.test(trimmed)) return true;
    // Allow common patterns without protocol (drive.google.com, dropbox.com, etc.)
    if (/^[a-zA-Z0-9]([a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}(\/.*)?$/.test(trimmed)) return true;
    return false;
  } catch {
    return false;
  }
}

/**
 * Normalize a URL to an absolute URL with a scheme.
 * A scheme-less value (e.g. "paypal.me/name") used directly in an <a href>
 * is treated by the browser as a RELATIVE path and resolved against the
 * current page (producing e.g. portal.uncutgems.com/admin/paypal.me/name).
 * Prepend https:// when no http(s) scheme is present so the link is absolute.
 */
export function ensureAbsoluteUrl(url) {
  if (!url || !url.trim()) return url;
  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}
